angular.module('forms').directive('apFormAnswerRadiobutton',
    ['$rootScope',
        function ($rootScope) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormAnswerRadiobutton.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    form: '=form',
                    question: '=question',
                    answer: '=answer',
                    lastQuestion: '@lastQuestion',
                    selectedButtonCallback: '&selectedButtonCallback'
                },
                controller: function($scope) {

                    function disableTriggeredQuestions() {
                        var answer = $scope.answer;
                        var question = $scope.question;
                        var questionsToDisable = [];

                        _.forEach(question.Answers, function(curAnswer) {
                            if (curAnswer.SurveyAnswerId !== answer.SurveyAnswerId) {
                                // if answer.QuestionsToTrigger collection is empty, do not add questionId to array
                                _.forEach(curAnswer.QuestionsToTrigger, function(questionToDisable) {
                                    if (questionToDisable !== '00000000-0000-0000-0000-000000000000') {
                                        if (questionsToDisable.indexOf(questionToDisable) === -1) {
                                            questionsToDisable.push(questionToDisable);
                                        }
                                    }
                                });
                            }
                        });

                        //console.log('Questions to disable : ' + questionsToDisable);
                        if (questionsToDisable.length <= 0) {
                            // No questions to enable or disable.  Therefore, do not fire disable question event.
                            return;
                        }

                        _.forEach(questionsToDisable, function(questionId) {
                            $rootScope.$broadcast('FormAnswerChanged',
                                {
                                    EnableQuestion: false,
                                    QuestionIdToTrigger: questionId
                                });
                        });
                    }


                    function enableQuestionsForSelectedAnswer() {
                        var answer = $scope.answer;

                        // if answer.QuestionsToTrigger collection is empty, do not fire enable event
                        _.forEach(answer.QuestionsToTrigger, function(questionToEnable) {
                            if (questionToEnable !== '00000000-0000-0000-0000-000000000000') {
                                $rootScope.$broadcast('FormAnswerChanged',
                                    {
                                        EnableQuestion: true,
                                        QuestionIdToTrigger: questionToEnable
                                    });
                            }
                        });
                    }


                    $scope.answerChanged = function answerChanged() {
                        disableTriggeredQuestions();
                        enableQuestionsForSelectedAnswer();

                        if ($scope.answer.SurveyAnswerId === $scope.question.SelectedAnswerId) {
                            if ($scope.answer.SurveyRequiresExplanation === true) {
                                if ((!$scope.answer.SurveyExplanation || $scope.answer.SurveyExplanation.length <= 0) && $scope.question.RequiredFieldsPopulated === true ) {
                                    $scope.question.RequiredFieldsPopulated = false;
                                }
                            }
                            else {
                                if ($scope.question.RequiredFieldsPopulated === false) {
                                    $scope.question.RequiredFieldsPopulated = true;
                                }
                            }
                        }

                        var selectedUid = $scope.question.SelectedAnswerId;
                        $scope.selectedButtonCallback(selectedUid);
                    };


                    $scope.explanationTextChanged = function explanationTextChanged() {
                        $rootScope.$broadcast('ExplanationTextChanged',
                            {
                                SurveyAnswerId: $scope.answer.SurveyAnswerId,
                                SurveyQuestionId: $scope.answer.SurveyQuestionId
                            }
                        );
                    };


                    function loadView() {
                    }
                    loadView();
                }
            };
        }
    ]
);